import BaseApi from './BaseApi'

class AdvisersApi extends BaseApi {
  get advisersUrl () {
    return 'advisers'
  }
  login (adviserId, agToken) {
    return this.postJson(`${this.advisersUrl}/login`, {
      adviserId: adviserId,
      agToken: agToken
    }).then(response => response.json())
  }

  getAllAdvisers () {
    return this.getJson(this.advisersUrl)
  }

  getAdviserProfiles (searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return this.getJson(`${this.advisersUrl}/search?searchTerm=${searchTerm}`)
  }

  setAdviserStatusCode (adviser) {
    return this.putJson(`${this.advisersUrl}/status`, adviser)
  }

  addAdviser (adviser) {
    return this.postJson(`${this.advisersUrl}/add`, adviser)
  }
}

export default AdvisersApi
